"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Body: function() {
        return _ModalBody.ModalBody;
    },
    Dialog: function() {
        return _ModalDialog.ModalDialog;
    },
    Footer: function() {
        return _ModalFooter.ModalFooter;
    },
    Header: function() {
        return _ModalHeader.ModalHeader;
    },
    HeaderTab: function() {
        return _ModalHeaderTab.ModalHeaderTab;
    },
    HeaderTabs: function() {
        return _ModalHeaderTabs.ModalHeaderTabs;
    },
    default: function() {
        return _default;
    }
});
const _ModalBody = require("./ModalBody/ModalBody");
const _ModalDialog = require("./ModalDialog");
const _ModalFooter = require("./ModalFooter/ModalFooter");
const _ModalHeader = require("./ModalHeader/ModalHeader");
const _ModalHeaderTab = require("./ModalHeaderTab/ModalHeaderTab");
const _ModalHeaderTabs = require("./ModalHeaderTabs/ModalHeaderTabs");
const _default = _ModalDialog.ModalDialog;

//# sourceMappingURL=index.js.map